import {useTranslation} from "react-i18next";
import {useEffect, useRef, useState} from "react";
import Form from "react-bootstrap/Form";
import Collapse from "react-bootstrap/Collapse";
import {Button, ButtonGroup, Dropdown} from "react-bootstrap";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import DataRange from "../../components/datetime/DataRange";
import moment from "moment";

const FormFiltersModel = {
    type: "",
    read: "",
};

const BoxFilters = ({filtersRef, show}) => {
    const {t: __Tt} = useTranslation("tables");
    const {t: __Tc} = useTranslation("choices");

    const [filters, setFilters] = useState({...FormFiltersModel});

    const [dateRange, setDateRange] = useState();

    const defaultRange = useRef({
        start: moment().subtract(7, "days"),
        end: moment(),
        startString: "",
        endString: "",
    });

    useState(() => {
        defaultRange.current.startString = defaultRange.current.start.format("DD-MM-YYYY");
        defaultRange.current.endString = defaultRange.current.end.format("DD-MM-YYYY");
        setDateRange(`${defaultRange.current.startString} | ${defaultRange.current.endString}`);

        filtersRef.current.chosen.start_date = defaultRange.current.start.format("YYYY-MM-DD");
        filtersRef.current.chosen.end_date = defaultRange.current.end.format("YYYY-MM-DD");
    }, []);

    function onChangeSelect(e) {
        const name = e.target.name.replace("filter-", "");
        const value = e.target.value;

        setFilters((prevFilters) => ({
            ...prevFilters,
            [name]: value,
        }));

        filtersRef.current.chosen[name] = value;
    }

    const applyAllFilters = () => {
        filtersRef.current.filter();
    };

    const handleClearFilters = () => {
        setFilters({...FormFiltersModel});
        filtersRef.current.clear();
        clearDateRange();
        applyAllFilters();
    };

    const changeDateRange = (start, end) => {
        const momentStart = moment(start);
        const momentEnd = moment(end);
        setDateRange(`${momentStart.format("DD-MM-YYYY")} | ${momentEnd.format("DD-MM-YYYY")}`);
        filtersRef.current.chosen.start_date = momentStart.format("YYYY-MM-DD");
        filtersRef.current.chosen.end_date = momentEnd.format("YYYY-MM-DD");
    };

    const clearDateRange = () => {
        setDateRange(`${defaultRange.current.startString} | ${defaultRange.current.endString}`);
        filtersRef.current.chosen.start_date = defaultRange.current.start.format("YYYY-MM-DD");
        filtersRef.current.chosen.end_date = defaultRange.current.end.format("YYYY-MM-DD");
    };

    return (
        <Collapse in={show}>
            <div id="filter-collapse">
                <div className="row">
                    <Button variant="link" type="button" onClick={handleClearFilters} style={{color: "black"}} className="col-1">
                        <FontAwesomeIcon icon="filter-circle-xmark" />
                    </Button>

                    <div className="col" style={{maxWidth: "140px"}}>
                        <label
                            style={{
                                width: "100%",
                                fontWeight: "bold",
                                textAlign: "center",
                            }}>
                            {__Tt("notifications.read")}
                        </label>
                        <Form.Select aria-label="Selector de estado" name="filter-read" onChange={onChangeSelect}>
                            <option value="">{__Tc("labels.all")}</option>
                            <option value="true">{__Tt("notifications.read_")}</option>
                            <option value="false">{__Tt("notifications.unread")}</option>
                        </Form.Select>
                    </div>
                    <div className="col" style={{maxWidth: "140px"}}>
                        <label
                            style={{
                                width: "100%",
                                fontWeight: "bold",
                                textAlign: "center",
                            }}>
                            {__Tt("common.type")}
                        </label>
                        <Form.Select aria-label="Selector de estado" name="filter-type" onChange={onChangeSelect}>
                            <option value="">{__Tc("labels.all")}</option>
                            <option value="t">{__Tc("notifyTypes.t")}</option>
                            <option value="r">{__Tc("notifyTypes.r")}</option>
                            <option value="s">{__Tc("notifyTypes.s")}</option>
                            <option value="i">{__Tc("notifyTypes.i")}</option>
                            <option value="e">{__Tc("notifyTypes.e")}</option>
                            <option value="p">{__Tc("notifyTypes.p")}</option>
                        </Form.Select>
                    </div>
                    <div className="col" style={{maxWidth: "140px"}}>
                        <label
                            style={{
                                width: "100%",
                                fontWeight: "bold",
                                textAlign: "center",
                            }}>
                            {__Tt("common.status")}
                        </label>
                        <Form.Select aria-label="Selector de estado" name="filter-status" onChange={onChangeSelect}>
                            <option value="">{__Tc("labels.all")}</option>
                            <option value="s">{__Tc("resultStatus.s")}</option>
                            <option value="i">{__Tc("resultStatus.i")}</option>
                            <option value="w">{__Tc("resultStatus.w")}</option>
                            <option value="e">{__Tc("resultStatus.e")}</option>
                        </Form.Select>
                    </div>
                    <div className="col-2">
                        <label style={{width: "100%", fontWeight: "bold", textAlign: "center"}}>
                            {__Tt("notifications.date_range")}
                        </label>

                        <ButtonGroup className="w-100">
                            <Dropdown className="w-100">
                                <Dropdown.Toggle
                                    variant="Secondary"
                                    id="dropdown-basic"
                                    style={{border: "1px solid #ced4da", minWidth: "100%"}}
                                    className="custom-dropdown-toggle">
                                    <FontAwesomeIcon icon="fa-solid fa-calendar-day" />
                                    <label style={{width: "90%", textAlign: "center"}}> {dateRange}</label>
                                </Dropdown.Toggle>
                                <Dropdown.Menu>
                                    <DataRange rangeData={changeDateRange} maxSpan={30} maxDate={new Date()} />
                                </Dropdown.Menu>
                            </Dropdown>
                        </ButtonGroup>
                    </div>

                    <div className="col-1">
                        <label style={{width: "100%", fontWeight: "bold", textAlign: "center"}}>&nbsp;</label>
                        <Button
                            variant="link"
                            type="button"
                            onClick={clearDateRange}
                            style={{color: "black"}}
                            className="btn-outline-secondary "
                            title="Limpiar fechas">
                            <FontAwesomeIcon icon="xmark" />
                        </Button>
                    </div>

                    <div className="col-1">
                        <label style={{width: "100%", fontWeight: "bold", textAlign: "center"}}>&nbsp;</label>
                        <Button
                            variant="link"
                            type="button"
                            onClick={applyAllFilters}
                            style={{color: ""}}
                            className="btn-outline-primary "
                            title="Aplicar">
                            <FontAwesomeIcon icon="magnifying-glass" />
                        </Button>
                    </div>
                </div>
            </div>
        </Collapse>
    );
};

export default BoxFilters;
